import React, {Component} from "react";
import {
    ShareButtons,
    ShareCounts,
    generateShareIcon,
    FacebookShareButton,
    GooglePlusShareButton,
    TwitterShareButton,
    FacebookShareCount,
    GooglePlusShareCount,
    FacebookIcon,
    TwitterIcon,
    GooglePlusIcon,
} from "react-share";
import config from "../../../meta/config";
import "./styles.sass";

class Share extends Component {
    render() {
        const {title, slug, excerpt, mobile} = this.props;
        const realPrefix = config.pathPrefix === "/" ? "" : config.pathPrefix;
        const url = config.siteUrl + realPrefix + slug;

        const iconSize = mobile ? 36 : 48;
        const filter = count => (count > 0 ? count : "");

        return (
            <div className="social-links">
                <TwitterShareButton url={url} title={title}>
                    <TwitterIcon round size={iconSize}/>
                </TwitterShareButton>
                <GooglePlusShareButton url={url}>
                    <GooglePlusIcon round size={iconSize}/>
                    <GooglePlusShareCount url={url}>
                        {count => <div className="share-count">{filter(count)}</div>}
                    </GooglePlusShareCount>
                </GooglePlusShareButton>
                <FacebookShareButton url={url} quote={excerpt}>
                    <FacebookIcon round size={iconSize}/>
                    <FacebookShareCount url={url}>
                        {count => <div className="share-count">{filter(count)}</div>}
                    </FacebookShareCount>
                </FacebookShareButton>
            </div>
        );
    }
}

export default Share;



// WEBPACK FOOTER //
// ./src/components/Share/index.js